import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`
        text-text 
        rounded-lg 
        p-6 
        shadow-xl 
        border  
        border-primary/20
        transition-all 
        duration-300 
        hover:shadow-2xl 
        hover:border-primary/20 
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;